import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { withRouter } from 'react-router';

import CrmDuplicateNotification from './notification-types/CrmDuplicateNotification';
import CrmCrossCheckNotification from './notification-types/CrmCrossCheckNotification';
import PassiveGenericNotification from './notification-types/PassiveGenericNotification';
import MarkAsRead from './MarkAsRead';

const propTypes = {
  notification: PropTypes.object.isRequired,
  onReadAt: PropTypes.func.isRequired,
};

const handleClick = (event, props, path) => {
  event.preventDefault();

  const { notification, onReadAt, history } = props;
  const { read_at, id, target } = notification;

  // mark notification as read
  if (!read_at) {
    onReadAt(id, false);
  }

  if (!target) {
    return;
  }

  history.push(`${path}?deviceId=${target.device_id}`);
};

const setLinkElements = (notification) => {
  let path;
  let icon;
  let Component;

  const { notice_type } = notification;

  switch (notice_type) {
    case 'crm_duplicate':
      path = '/qa/crm/duplicates/new';
      icon = 'copy';
      Component = CrmDuplicateNotification;
      break;
    case 'crm_cross_check':
      path = '/qa/crm/cross-check-tests/new';
      icon = 'copy';
      Component = CrmCrossCheckNotification;
      break;
    case 'passive_duplicate':
      path = '';
      icon = 'copy';
      Component = () => <PassiveGenericNotification noticeType="duplicate" />;
      break;
    case 'passive_blank':
      path = '';
      icon = 'copy';
      Component = () => <PassiveGenericNotification noticeType="blank" />;
      break;
    case 'passive_spike':
      path = '';
      icon = 'copy';
      Component = () => <PassiveGenericNotification noticeType="spike" />;
      break;
    default:
      throw new Error('');
  }

  return { path, icon, Component };
};

const NotificationItem = (props) => {
  const { notification, onReadAt } = props;
  const { id, read_at, created_at, notice_type } = notification;
  const { path, icon, Component } = setLinkElements(notification);

  return (
    <li key={id}>
      <a
        href="true"
        onClick={(e) => handleClick(e, props, path)}
        className={`NotificationsList__item ${read_at ? 'NotificationsList__item--read' : ''}`}
      >
        <div className="NotificationsList__item-inner">
          <div className={`NotificationsList__item-icon ${notice_type}`}>
            <span>
              <FontAwesomeIcon icon={['fal', icon]} />
            </span>
          </div>
          <div className="NotificationsList__item-text">
            <Component notification={notification} />
            <div className="time">
              {moment(created_at).fromNow()}
            </div>
          </div>
        </div>
        <div className="NotificationsList__item-actions">
          <MarkAsRead
            onClick={() => onReadAt(id)}
            isRead={read_at}
            id={id}
          />
        </div>
      </a>
    </li>
  );
};

NotificationItem.propTypes = propTypes;

export default withRouter(NotificationItem);



// WEBPACK FOOTER //
// ./src/features/dashboard/NotificationItem.js